import { Directive, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

export enum AdditionalInputType {
  Voucher = 'voucher',
  Bin = 'bin',
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[osnSharedEmailCollectorAdditionalControl]',
})
export class EmailCollectorAdditionalControlDirective {
  @Input() public additionalInputKey: AdditionalInputType;
  @Input() public formControl: FormControl;
  @Input() public validatorRegexp?: RegExp;
}
